export const otherArrangement = {
  arrangementType: {
    etas: "ETAS",
    restaurant_reservation_fee: "レストラン予約フィー",
  },
};
